export default __webpack_public_path__ + "static/media/alert-light.073737aa.svg";